/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface AbbreviatedTalentRequest {

    id?: string;

    /**
     * Name of the person
     */
    name?: string;

    /**
     * Title of the person
     */
    title?: string;

    /**
     * Bio for the person
     */
    bio?: string;

    /**
     * First portrait for person
     */
    thumbnail_portrait1?: string;

    /**
     * First portrait for person
     */
    thumbnail_portrait2?: string;

    /**
     * First landscape image for person
     */
    thumbnail_landscape1?: string;

    /**
     * First landscape image for person
     */
    landscape2?: string;

}

@Model('AbbreviatedTalent')
export class ApiAbbreviatedTalent extends BaseModel implements AbbreviatedTalentRequest {

    
    
    id: string;

    /**
     * Name of the person
     */
    
    
    name: string;

    /**
     * Title of the person
     */
    
    
    title: string;

    /**
     * Bio for the person
     */
    
    
    bio: string;

    /**
     * First portrait for person
     */
    
    
    thumbnail_portrait1: string;

    /**
     * First portrait for person
     */
    
    
    thumbnail_portrait2: string;

    /**
     * First landscape image for person
     */
    
    
    thumbnail_landscape1: string;

    /**
     * First landscape image for person
     */
    
    
    landscape2: string;

}
